export const overrides = {
  MuiLink: {
    root: {
      color: "#1976d2"
    }
  }
};
